import React, { useEffect, useState } from 'react';
import { Button, Flex } from '@adobe/react-spectrum';
import PropTypes from 'prop-types';
import Container from './taskStatusStyles';
import OBJCODE from '../../constants';
import actionWebInvoke from '../../utils/actionCallUtils';
import actions from '../../config.json';

const TaskStatus = ({
  id,
  status,
  assignmentID,
  isTaskStatusUpdated,
  setTaskStatusUpdated,
}) => {
  const [state, setState] = useState({
    isLoading: true,
    elements: [],
  });
  const [isPossibleToStart, setIsPossibleToStart] = useState(false);

  async function updateTaskStatus(assignementStatus, taskStatus) {
    setState({ ...state, isLoading: true });
    const queryParams = {
      updates: JSON.stringify({
        assignments: [{ ID: assignmentID, status: assignementStatus }],
        status: taskStatus,
      }),
      method: 'PUT',
    };
    await actionWebInvoke(
      actions['workfront-action'],
      {},
      { objCode: OBJCODE.TASK, objID: id, queryParams },
    );
    setTaskStatusUpdated(!isTaskStatusUpdated);
  }

  useEffect(() => {
    if (status === 'AA' || status === 'DN') {
      setIsPossibleToStart(true);
    } else if (status === 'AD') {
      setIsPossibleToStart(false);
    }
  }, [status]);

  return (
    <Container>
      <p>Update task status</p>
      <Flex>
        <Button
          isDisabled={!isPossibleToStart}
          variant="cta"
          UNSAFE_className="button-stretch"
          onClick={() => {
            updateTaskStatus('AD', 'INP');
            setIsPossibleToStart(false);
          }}
        >
          Start
        </Button>
        <Button
          isDisabled={isPossibleToStart}
          variant="cta"
          UNSAFE_className="button-stretch"
          onClick={() => {
            updateTaskStatus('DN', 'CPL');
            setIsPossibleToStart(true);
          }}
        >
          Complete
        </Button>
      </Flex>
    </Container>
  );
};

TaskStatus.propTypes = {
  id: PropTypes.string,
  status: PropTypes.string,
  assignmentID: PropTypes.string,
  isTaskStatusUpdated: PropTypes.string,
  setTaskStatusUpdated: PropTypes.string,
};

TaskStatus.defaultProps = {
  id: '',
  status: '',
  assignmentID: '',
  isTaskStatusUpdated: '',
  setTaskStatusUpdated: '',
};

export default TaskStatus;
